// i18n
import { useTranslation } from 'react-i18next';

// mui
import { SelectChangeEvent, SelectProps } from '@mui/material';

// fields
import { SelectLocale } from '../SelectLocale/SelectLocale';

export const SelectLanguage = ({ ...props }: SelectProps) => {
	// hooks
	const { t, i18n } = useTranslation();

	// handlers
	const handleChangeLang = (e: SelectChangeEvent<unknown>) => {
		const { value } = e.target as HTMLInputElement;
		const localeArray = value.split('-');

		// change lang
		i18n.changeLanguage(localeArray[0]);
	};

	return (
		<SelectLocale
			aria-label={t('language')}
			defaultValue="en-US"
			{...props}
			onChange={handleChangeLang}
		/>
	);
};
